import axios from "axios";

export const ATTACHMENTS_URL = `${process.env.REACT_APP_API_URL}/attachments`;

// READ


export function FindAttachments(model, recordId){
    return axios.get(ATTACHMENTS_URL, {
        params: {
            model,
            recordId
        }
    })
}

export function FetchAttachment(id){
    return axios.get(`${ATTACHMENTS_URL}/${id}`, {
        responseType: 'blob'
    })
}

export function DeleteAttachment(id){
    return axios.delete(`${ATTACHMENTS_URL}/${id}`);
}